import { getRequest } from '.'

export const getEncounterCreatures = async (
  encounterId: number,
): Promise<wowaudit.EncounterCreature[]> => {
  return getRequest(`/api/encounter_creatures?encounter_id=${encounterId}`)
}
